import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import DateRangeSelect from './dateRangeSelect';
import { COMPARISON_RANGE_KEY, ComparisonRange, getComparisonRange } from './default/comparisonRanges';

interface ComparisonDateRangeSelectProps {
    mainDateRange: any;
    comparedDateRange: any;
    handleChangeComparedDateRangeScope: (dateRange: any) => void;
    maxDate?: Date;
    minDate?: Date;
}

const ComparisonDateRangeSelect: FC<ComparisonDateRangeSelectProps> = ({ mainDateRange, comparedDateRange, handleChangeComparedDateRangeScope, maxDate, minDate }) => {
    const { t } = useTranslation('dashboard');
    const mainSelection = mainDateRange?.selection;

    const shortcuts = [
        { key: COMPARISON_RANGE_KEY.PREVIOUS_YEAR_EQUIVALENT, label: t('temporalScope.comparisonRanges.previousYearEquivalent') },
        { key: COMPARISON_RANGE_KEY.PREVIOUS_PERIOD_EQUIVALENT, label: t('temporalScope.comparisonRanges.previousPeriodEquivalent') },
        { key: COMPARISON_RANGE_KEY.PREVIOUS_WEEK, label: t('temporalScope.comparisonRanges.previousWeek') },
        { key: COMPARISON_RANGE_KEY.PREVIOUS_MONTH, label: t('temporalScope.comparisonRanges.previousMonth') },
        { key: COMPARISON_RANGE_KEY.PREVIOUS_YEAR, label: t('temporalScope.comparisonRanges.previousYear') },
    ];

    // Every shortcut reads the main period, so none of them is offered while no
    // period is selected, and none needs a fallback range.
    const customStaticRanges = shortcuts
        .map(({ key, label }) => ({ label, range: getComparisonRange(key, mainSelection) }))
        .filter((shortcut): shortcut is { label: string, range: ComparisonRange } => shortcut.range !== null)
        .map(({ label, range }) => ({ label, range: () => range }));

    return (
        <DateRangeSelect
            customStaticRanges={customStaticRanges}
            dateRange={comparedDateRange}
            handleChangeDateRangeScope={handleChangeComparedDateRangeScope}
            maxDate={maxDate}
            minDate={minDate}
        />
    );
};

export default ComparisonDateRangeSelect;
